// Mock data for Ekaanshi Indoor website

export const heroImages = [
  "https://images.unsplash.com/photo-1704040686684-be330b48412e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjkxMDMzNjR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1533779283484-8ad4940aa3a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxuYXR1cmFsJTIwbGlnaHR8ZW58MHx8fHwxNzY5MTAzMzY5fDA&ixlib=rb-4.1.0&q=85"
];

export const upvcImages = [
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621105/Screenshot_2026-01-28_at_10.39.12_PM_pdf21z.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621106/Screenshot_2026-01-28_at_10.40.00_PM_u5nquw.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621105/Screenshot_2026-01-28_at_10.41.01_PM_g4urui.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621386/Gemini_Generated_Image_to932eto932eto93_vrtimp.png"
];

export const aluminiumImages = [
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621575/Gemini_Generated_Image_852h29852h29852h_uwchws.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621676/Gemini_Generated_Image_80e3mp80e3mp80e3_htrgcz.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621772/Gemini_Generated_Image_aezmosaezmosaezm_vt4kyy.png",
  "https://res.cloudinary.com/dj0pts1x1/image/upload/v1769621884/Gemini_Generated_Image_n3eldan3eldan3el_xrpeln.png"
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7",
    title: "Modern Living Room",
    category: "residential"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1610177534644-34d881503b83",
    title: "Contemporary Kitchen",
    category: "residential"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431",
    title: "Elegant Living Space",
    category: "residential"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1606744888344-493238951221",
    title: "Luxury Interior",
    category: "commercial"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1748052132908-3e489c4eb542",
    title: "Interior with View",
    category: "residential"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1667375186016-db03fabfc259",
    title: "Contemporary Design",
    category: "commercial"
  }
];

export const products = [
  {
    id: 1,
    category: "uPVC",
    name: "uPVC Doors",
    description: "Premium quality uPVC doors with excellent insulation and durability. Perfect for residential and commercial applications.",
    image: upvcImages[0],
    features: ["Energy Efficient", "Weather Resistant", "Low Maintenance", "Durable"]
  },
  {
    id: 2,
    category: "uPVC",
    name: "uPVC Windows",
    description: "Modern uPVC windows offering superior thermal performance and sound insulation for comfortable living spaces.",
    image: upvcImages[1],
    features: ["Thermal Insulation", "Sound Proof", "Easy to Clean", "Long Lasting"]
  },
  {
    id: 3,
    category: "uPVC",
    name: "Sliding Doors",
    description: "Sleek sliding door systems that maximize space and natural light while maintaining energy efficiency.",
    image: upvcImages[2],
    features: ["Space Saving", "Smooth Operation", "Modern Design", "Secure"]
  },
  {
    id: 4,
    category: "uPVC",
    name: "French Doors",
    description: "Elegant French doors combining classic aesthetics with modern uPVC technology for stunning entryways.",
    image: upvcImages[3],
    features: ["Elegant Design", "Wide Opening", "Natural Light", "Secure Locking"]
  },
  {
    id: 5,
    category: "Aluminium",
    name: "Aluminium Doors",
    description: "Robust aluminium doors engineered for strength, security, and contemporary design appeal.",
    image: aluminiumImages[0],
    features: ["High Strength", "Corrosion Resistant", "Slim Frames", "Modern Look"]
  },
  {
    id: 6,
    category: "Aluminium",
    name: "Aluminium Windows",
    description: "Sleek aluminium windows with minimal sightlines, maximum glass area, and exceptional performance.",
    image: aluminiumImages[1],
    features: ["Slim Profile", "Large Glass Area", "Lightweight", "Durable"]
  },
  {
    id: 7,
    category: "Aluminium",
    name: "Sliding Systems",
    description: "Advanced aluminium sliding systems offering effortless operation and contemporary architectural design.",
    image: aluminiumImages[2],
    features: ["Smooth Sliding", "Space Efficient", "Modern Design", "Easy Access"]
  },
  {
    id: 8,
    category: "Aluminium",
    name: "Glass Facades",
    description: "Stunning glass facade systems with aluminium framing for commercial and high-end residential projects.",
    image: aluminiumImages[3],
    features: ["Architectural Design", "Maximum Light", "Weather Proof", "Premium Finish"]
  }
];

export const services = [
  {
    id: 1,
    title: "Consultation & Site Inspection",
    description: "Our expert team visits your site to understand requirements, take measurements, and provide professional recommendations tailored to your needs.",
    icon: "Clipboard"
  },
  {
    id: 2,
    title: "Custom Design Solutions",
    description: "We create bespoke designs that perfectly match your architectural vision, ensuring seamless integration with your space.",
    icon: "Ruler"
  },
  {
    id: 3,
    title: "Manufacturing & Installation",
    description: "State-of-the-art manufacturing facilities and skilled installation teams ensure precision fitting and flawless execution.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "After-Sales Support & Maintenance",
    description: "Comprehensive after-sales service including maintenance guidance, warranty support, and ongoing assistance.",
    icon: "Shield"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Premium Materials",
    description: "We use only the highest quality uPVC and aluminium materials from trusted manufacturers, ensuring longevity and superior performance.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Energy Efficiency",
    description: "Our products are designed to reduce energy consumption with excellent thermal insulation properties, lowering your utility bills.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Weather Resistance",
    description: "Built to withstand harsh weather conditions including heavy rain, extreme temperatures, and strong winds without deterioration.",
    icon: "Cloud"
  },
  {
    id: 4,
    title: "Sound Insulation",
    description: "Advanced sound dampening technology creates peaceful indoor environments by significantly reducing external noise pollution.",
    icon: "Volume2"
  },
  {
    id: 5,
    title: "Long Lifespan",
    description: "Engineered for durability, our doors and windows maintain their performance and appearance for decades with minimal maintenance.",
    icon: "Clock"
  },
  {
    id: 6,
    title: "Modern Aesthetics",
    description: "Contemporary designs with clean lines and customizable finishes that complement any architectural style, from classic to modern.",
    icon: "Sparkles"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Homeowner",
    content: "Ekaanshi Indoor transformed our home with their premium uPVC windows. The difference in energy efficiency and noise reduction is remarkable. Highly professional team!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Interior Designer",
    content: "As an interior designer, I've worked with many suppliers. Ekaanshi Indoor stands out for their quality, timely delivery, and attention to detail. Perfect for high-end projects.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Builder",
    content: "We've been partnering with Ekaanshi Indoor for our residential projects. Their aluminium systems are top-notch, and installation is always seamless. Excellent value for money.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is the difference between uPVC and Aluminium?",
    answer: "uPVC (unplasticized Polyvinyl Chloride) offers excellent thermal insulation and is ideal for residential applications. Aluminium provides superior strength, slim frames, and is preferred for larger openings and commercial projects. Both are durable, low-maintenance, and weather-resistant."
  },
  {
    id: 2,
    question: "How long does installation take?",
    answer: "Installation time varies based on project size. Typically, a standard residential installation takes 1-3 days. We provide a detailed timeline during the consultation phase and ensure minimal disruption to your daily routine."
  },
  {
    id: 3,
    question: "Do you provide warranty on your products?",
    answer: "Yes, we offer comprehensive warranty coverage on all our products. uPVC products come with 10-year warranty, while aluminium systems have 5-year warranty. This covers manufacturing defects and material quality."
  },
  {
    id: 4,
    question: "Can I customize the colors and finishes?",
    answer: "Absolutely! We offer a wide range of colors, finishes, and textures for both uPVC and aluminium products. From classic white to woodgrain finishes and custom RAL colors, we can match your aesthetic preferences."
  },
  {
    id: 5,
    question: "Do you handle both residential and commercial projects?",
    answer: "Yes, we cater to both residential and commercial clients. Our portfolio includes apartments, villas, office buildings, hotels, and retail spaces. We have the expertise and capacity to handle projects of all scales."
  },
  {
    id: 6,
    question: "What maintenance is required?",
    answer: "Both uPVC and aluminium require minimal maintenance. Regular cleaning with mild soap and water is sufficient. We provide detailed maintenance guidelines and offer periodic servicing to ensure long-lasting performance."
  }
];

export const contactInfo = {
  email: "ekaanshiindoor@gmail.com",
  phone: "+91-7017168371",
  whatsapp: "+91-7017168371",
  address: "26MI Balaji Kunj Phase II Muradnagar Ghaziabad Uttar Pradesh (201206)",
  instagram: "https://www.instagram.com/ekaanshiindoor/",
  mapUrl:"https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d746.508088606509!2d77.49367167012394!3d28.762344979688674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1769401951958!5m2!1sen!2sin"
};